module.exports = __webpack_public_path__ + "static/media/account1.ada30703.svg";